import React from "react";

const fontUrl = asset => {
  if (
    asset.attributes.asset_data.hex ||
    asset.attributes.asset_data.r ||
    asset.attributes.asset_data.c
  ) {
    if (asset.attributes.asset_data.hex) {
      let hex = asset.attributes.asset_data.hex.toLowerCase();
      return `http://colorhexa.com/${hex}`;
    } else if (asset.attributes.asset_data.r) {
      let rgb =
        asset.attributes.asset_data.r +
        "+" +
        asset.attributes.asset_data.g +
        "+" +
        asset.attributes.asset_data.b;
      return `http://colorhexa.com/color.php?c=rgb+${rgb}`;
    } else if (asset.attributes.asset_data.c) {
      let cmyk =
        asset.attributes.asset_data.c +
        "+" +
        asset.attributes.asset_data.m +
        "+" +
        asset.attributes.asset_data.y +
        "+" +
        asset.attributes.asset_data.k;
      return `http://colorhexa.com/color.php?c=cmyk+${cmyk}`;
    }
  }
};

const ColorLink = ({ asset } = props) => (
  <a href={fontUrl(asset)} target="_blank">
    <button className="noline button primary lg">
      <svg
        className="attachment-icon"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 99.89 99.9"
      >
        <path
          fill="#FFFFFF"
          d="M83.31,54.13a33.24,33.24,0,0,1-6.85,16.42L88.23,82.32A49.89,49.89,0,0,0,99.89,54.13Z"
        />
        <path
          fill="#FFFFFF"
          d="M54.13,83.14V99.9A49.91,49.91,0,0,0,82.32,88.24L70.52,76.43a33.21,33.21,0,0,1-16.39,6.71Z"
        />
        <path
          fill="#FFFFFF"
          d="M29.55,76.25l-12,12A49.89,49.89,0,0,0,45.77,99.9V83.07a33.28,33.28,0,0,1-16.22-6.82Z"
        />
        <path
          fill="#FFFFFF"
          d="M17,54.13H0A49.89,49.89,0,0,0,11.66,82.32l12-12A33.21,33.21,0,0,1,17,54.13Z"
        />
        <path
          fill="#FFFFFF"
          d="M23.68,29.59l-12-12A49.86,49.86,0,0,0,0,45.77H17a33.18,33.18,0,0,1,6.66-16.19Z"
        />
        <path
          fill="#FFFFFF"
          d="M45.77,16.83V0A49.9,49.9,0,0,0,17.57,11.67l12,12a33.25,33.25,0,0,1,16.22-6.82Z"
        />
        <path
          fill="#FFFFFF"
          d="M52.71,54.46a10,10,0,0,1-5.32,2.29h-.18l-4.12-4.12v-.18a10,10,0,0,1,2.29-5.32L63.7,28.81,71,36.14Zm33-18.32L82,32.48,96.66,17.83A10.36,10.36,0,0,0,82,3.18L67.36,17.82,63.7,14.16a5.18,5.18,0,0,0-7.32,7.33L60,25.15,41.72,43.47a15,15,0,0,0-3.8,8.84l-.07,2.4.86,6.41,6.41.86,2.41-.06a15,15,0,0,0,8.84-3.8L74.68,39.8l3.66,3.66a5.18,5.18,0,0,0,7.34-7.32Z"
        />
      </svg>
      {t('View on ColorHexa')}
    </button>
  </a>
);

export default ColorLink;
